import { useRef } from 'react'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import SnowflakeIcon from 'assets/svgr-icons/Snowflake.svg'
import { useFrameExtraction } from './useFrameExtraction'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from 'hooks/useResponsive'
import { useDropdownState } from 'hooks/useDropdownState'
import { ActionsFlyout, ActionsMenu } from 'common-components'
import { useMobileDrawerContext } from 'context/MobileDrawerContext'

import CurrentFrameIcon from 'assets/svgr-icons/CurrentFrame.svg'
import LastFrameIcon from 'assets/svgr-icons/LastFrame.svg'

const iconProps = {
  iconSize: {
    width: 20,
    height: 20
  },
  isStrokedIcon: true
}

export const FrameExtractButton = () => {
  const {
    handleExtractCurrentFrame,
    handleExtractLastFrame,
    isButtonDisabled
  } = useFrameExtraction()

  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)
  const togglerRef = useRef(null)
  const { isOpen, closeDropdown, toggleDropdown } = useDropdownState()
  const { openDrawer, closeDrawer } = useMobileDrawerContext()

  const frameExtractOptions = [
    {
      key: 'current_frame',
      title: translate(T.CURRENT_FRAME),
      icon: <CurrentFrameIcon />,
      onClick: handleExtractCurrentFrame,
      ...iconProps
    },
    {
      key: 'last_frame',
      title: translate(T.LAST_FRAME),
      icon: <LastFrameIcon />,
      onClick: handleExtractLastFrame,
      ...iconProps
    }
  ]

  if (isMobile) {
    const openFreezeDrawer = () =>
      openDrawer(
        <ActionsMenu
          actions={frameExtractOptions}
          onClose={closeDrawer}
          isMobileDrawerStyle
        />
      )

    return (
      <ActionButton
        icon={<SnowflakeIcon />}
        tooltipText={translate(T.FREEZE_FRAME_LABEL)}
        title={translate(T.FREEZE_FRAME_LABEL)}
        onClick={openFreezeDrawer}
        disabled={isButtonDisabled}
      />
    )
  }

  return (
    <>
      <ActionButton
        ref={togglerRef}
        icon={<SnowflakeIcon />}
        tooltipText={translate(T.FREEZE_FRAME_LABEL)}
        onClick={toggleDropdown}
        disabled={isButtonDisabled}
      />
      <ActionsFlyout
        actions={frameExtractOptions}
        isOpen={isOpen}
        anchorEl={togglerRef?.current}
        onClose={closeDropdown}
        flyoutOptions={{
          position: 'right',
          alignmentY: 'top',
          extraOffset: 8
        }}
      />
    </>
  )
}
